module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "perosnal-content",
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('div', {
    staticClass: "perosnal-content",
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('div', {
    staticClass: "personal-preview-image",
    staticStyle: {
      "background": "transparent"
    }
  }, [(_vm.model.playingVideo != null) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": "20px"
    },
    attrs: {
      "id": "videoIframe",
      "src": _vm.model.playingVideo,
      "sandbox": "allow-scripts allow-same-origin allow-presentation allow-popups",
      "frameborder": "0",
      "allow": "accelerometer;  clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "referrerpolicy": "strict-origin-when-cross-origin",
      "allowfullscreen": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-title"
  }, [_vm._v(_vm._s(_vm.getName(_vm.model)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-desc"
  }, [_vm._v("--" + _vm._s(_vm.getShortDesc(_vm.model)) + "--")]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-text"
  }, [_c('p', {
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatLinks(_vm.getLongDesc(_vm.model)))
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b39a87a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Knowledge/KnowledgeDetails.vue
// module id = 803
// module chunks = 0